// extracted by mini-css-extract-plugin
module.exports = {"block":"General_block__oUa9p","title":"General_title__3V64N","description":"General_description__2Tmgx"};